<h2 mat-dialog-title>{{ 'termsOfUse.title' | translate }}</h2>

<mat-dialog-content class="mt-3">
  <div class="d-flex gap-3">
    <div class="text-muted flex-shrink-0">
      <mat-icon fontIcon="mdi-file-document-outline" class="terms-of-use-icon"></mat-icon>
    </div>
    <div>
      <p>{{ 'termsOfUse.message' | translate }}</p>
      <a [href]="data.termsPageUrl" target="_blank" rel="noopener noreferrer">
        {{ 'termsOfUse.linkText' | translate }} </a
      >{{ 'termsOfUse.linkLabel' | translate }}
    </div>
  </div>
  <div class="d-flex align-items-start mt-3">
    <mat-checkbox [formControl]="confirmed">
      {{ 'termsOfUse.confirm' | translate }}
    </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-between">
  <button mat-button (click)="decline()">
    {{ 'termsOfUse.decline' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="!confirmed.value" (click)="accept()">
    {{ 'termsOfUse.accept' | translate }}
  </button>
</mat-dialog-actions>
